export default __webpack_public_path__ + "static/media/gflogo.4e05d0cf.png";